export default __webpack_public_path__ + "static/media/evaluate-icons.6c52efc5.svg";